type Available = {
  code: number;
  deliveries: Delivery[];
  name: string;
};

type BusinessModel = {
  availables: Available[];
  default: Default;
};

type Default = {
  code: number;
  delivery: Delivery;
  name: string;
};

type Delivery = {
  address: string;
  distributionCenterCode: number;
  distributionCenterName: string;
  isWithdrawalCenter: boolean;
};

type CycleProps = {
  currentCycle: number;
  daysLeft: number;
  daysTotal: number;
  initialDate: string;
  finalDate: string;
  toleranceDays?: number;
  brand?: string;
  name?: string;
  isMultiBrand?: boolean;
};
type CyclesProps = {
  currentCycle: number;
  daysLeft: number;
  daysTotal: number;
  initialDate: string;
  finalDate: string;
  toleranceDays?: number;
  brand?: 'BOTICARIO' | 'EUDORA';
  name?: string;
  isMultiBrand?: boolean;
};

type Cycles = {
  cycles: CyclesProps[];
  canChooseCycle: boolean;
  canBuyOnlyInER: boolean;
  status: string;
  message: string;
};

export type UserProps = {
  brand: string;
  cycle: {
    currentCycle: number;
    daysLeft: number;
    daysTotal: number;
    initialDate: string;
    finalDate: string;
    nextCycle: number;
  };
  cycles: Cycles;
  fullAddress: string;
  isBlocked: boolean;
  isCeased: boolean;
  isMultiBrand: boolean;
  isWithdrawalCenter: boolean;
  name: string;
  region: string;
  resellerId: string;
  shippingModel: BusinessModel;
  supervisor: Supervisor;
  isExtendedCapitation: boolean;
  isResaleIntention: boolean;
  isAutoStartEnabled: boolean;
};

export type CreditType = {
  available: number;
  cashback: number;
  notOverdue: number;
  overdue: number;
  toBill: number;
  tolerancePercentage: number;
  total: number;
};

interface ResellerUser {
  creditData: CreditData;
  currentCycle: number;
  email: string;
  fullAddress: string;
  isMultiBrand: boolean;
  nextCycle: number;
  origin: string;
  phone: string;
  resellerBlocked: boolean;
  resellerDoc: string;
  resellerId: string;
  resellerInitials: string;
  resellerName: string;
  isResaleIntention: boolean;
  isAutoStartEnabled: boolean;
  isLoyaltyMember?: boolean;
}

interface CreditData {
  limit: number;
  allocatedToBill: number;
  allocatedToExpire: number;
  allocatedOverdue: number;
  availableBalance: number;
}

interface ComercialStructure {
  id: string;
  name: string;
  supervisor: Supervisor;
}

interface Supervisor {
  name: string;
  contacts: Contact[];
}

interface Contact {
  type: string;
  value: string;
}

export interface CycleUser {
  initialDate: string;
  finalDate: string;
  toleranceDays: number;
  cycleLength: number;
  cycleNumber: number;
  remainingDays: number;
  brands: string[];
}

export type AuthResponse = {
  access_token: string;
  expires_in: number;
  refresh_token?: string;
  session_state: string;
  token_origin: string;
  token_type: string;
};

export type AuthDetailResponse = {
  reseller: ResellerUser;
  comercialStructure: ComercialStructure;
  businessModel: BusinessModel;
  cycle: CycleUser[];
  isMarketable: boolean;
  isExtendedCapitation: boolean;
};

export type CustomerServiceType = {
  customerService: {
    email: string | null;
    whatsapp: string | null;
    phone: string | null;
  };
};

export type SupervisorType = {
  supervisor: {
    name: string | null;
    contacts:
      | [
          {
            contactType?: 'celular';
            value?: string | null;
          }
        ]
      | [];
  };
};

type ResaleIntentionFaqQuestions = {
  question: string;
  answer: string;
};

type ResaleIntentionWaitingToAutoStart = {
  isEnabledToView?: boolean;
  contentType?: string;
};

type ResaleIntentionAutoStartOnboard = {
  isEnabledToView: boolean;
};

export type ResaleIntentionType = {
  isResaleIntention: boolean;
  isAutoStartEnabled: boolean;
  isSaveOnCache: boolean;
  autoStartModal: ResaleIntentionAutoStartOnboard;
  onboardingHomePage: ResaleIntentionAutoStartOnboard;
  biometry: {
    isEnabledToView: boolean;
    status: string;
    link: string;
    risk: string;
    isFeaturesLimited: boolean;
  };
  waitingToAutoStart: {
    card: ResaleIntentionWaitingToAutoStart;
    modal: ResaleIntentionWaitingToAutoStart;
  };
  faq: {
    withCredit: {
      title: string;
      questions: Array<ResaleIntentionFaqQuestions>;
    };
    withoutCredit: {
      title: string;
      questions: Array<ResaleIntentionFaqQuestions>;
    };
  };
  campaignBanner?: {
    isEnabledToView: boolean;
    position: string;
  };
  changeToVDFInfo: {
    isEnabledToView: boolean;
    releaseDate: string;
  } | null;
};

export const enum UserHelpContact {
  SUPERVISOR = 'supervisor',
  CUSTOMER_SERVICE = 'customerService',
}
